import React from "react";
import { twMerge } from "tailwind-merge";

/**
 * @typedef {object} ButtonProps
 * @property {string} value - text inside the button
 * @property {"submit" | "button"} type - submit or button with an action
 * @property {(event) => void} [onClick] - what to do when clicked (callback)
 * @property {boolean} [disabled] - disabled or not
 */

/**
 * App component.
 * @param {ButtonProps} props - props
 * @returns {React.JSX.Element} - element
 */
function Button({ value, type = "submit", onClick, disabled }) {
  const buttonClasses = {
    submit: [
      "!fr-text-white !fr-border-primary-600 !fr-bg-primary-600 hover:fr-bg-primary-700 hover:fr-border-primary-700 focus-visible:fr-ring-primary-600",
    ],
    warning: [
      "fr-text-black !fr-border-yellow-400 !fr-bg-yellow-400 hover:fr-bg-yellow-600 hover:fr-border-yellow-600 focus-visible:fr-ring-yellow-600",
    ],
    error: [
      "fr-text-white !fr-border-red-600 !fr-bg-red-600 hover:fr-bg-red-800 hover:fr-border-red-800 focus-visible:fr-ring-red-600",
    ],
  };

  /**
   *
   * @param {React.SyntheticEvent<HTMLButtonElement> | React.MouseEvent} event - synthetic event
   * @returns {void}
   */
  function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
  }
  return (
    <input
      type={type}
      value={value}
      className={twMerge(
        "!fr-border fr-inline-flex fr-items-center fr-justify-center fr-rounded-md !fr-px-4 !fr-py-2 fr-text-sm fr-font-normal focus-visible:fr-outline-none focus-visible:fr-ring-1  focus-visible:fr-ring-offset-1 focus-visible:fr-ring-offset-gray-100 hover:fr-cursor-pointer disabled:fr-cursor-not-allowed disabled:fr-opacity-50",
        buttonClasses[type],
      )}
      onClick={(event) => onClick && handleClick(event)}
      disabled={disabled}
    />
  );
}

export default Button;
